import { Suspense } from "react";

import { V2Skeleton } from "@stacklet/ui";
import { graphql, useLazyLoadQuery } from "react-relay";

import { NotificationsSettingsPage } from "../../settings/components/NotificationsSettingsPage";
import { UpsertNotificationRuleStepsContainer } from "../components/UpsertNotificationRuleStepsContainer";
import { NotificationRuleFormContextProvider } from "../contexts/NotificationRuleFormContext";
import { CreateNotificationRuleHeader } from "./CreateNotificationRuleHeader";

import type { CreateNotificationRuleRootQuery } from "./__generated__/CreateNotificationRuleRootQuery.graphql";

export function CreateNotificationRuleRoot() {
  const data = useLazyLoadQuery<CreateNotificationRuleRootQuery>(
    graphql`
      query CreateNotificationRuleRootQuery {
        ...CreateNotificationRuleHeader_query
        ...NotificationsSettingsPage_query
      }
    `,
    {},
  );

  return (
    <NotificationsSettingsPage
      queryRef={data}
      title="Create Notification Rule"
      withHeader={false}
    >
      <>
        <CreateNotificationRuleHeader queryRef={data} />
        <Suspense
          fallback={
            <V2Skeleton
              aria-label="Loading form…"
              className="mt-lg"
              height="24rem"
              variant="rectangular"
            />
          }
        >
          <NotificationRuleFormContextProvider isEditMode={false}>
            <UpsertNotificationRuleStepsContainer />
          </NotificationRuleFormContextProvider>
        </Suspense>
      </>
    </NotificationsSettingsPage>
  );
}
